(function() {
  const THRESHOLD = 10000; // 100€ en centavos
  const TOTE_VARIANT_ID = '53250719023431';
  const TOTE_PRODUCT_ID = 10631460946247;
  let isProcessing = false;
  
  function updateCartUI() {
    // Disparar eventos para que el tema actualice el carrito
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    
    // Intentar actualizar secciones del carrito si existen
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach((section) => {
        fetch(`${window.location.pathname}?section_id=${section.id}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(`#${section.id}`);
            if (newContent) {
              document.querySelector(`#${section.id}`).innerHTML = newContent.innerHTML;
            }
          });
      });
    }
    
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach((section) => {
        fetch(`${window.location.pathname}?section_id=${section.id}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(`#${section.id}`);
            if (newContent) {
              document.querySelector(`#${section.id}`).innerHTML = newContent.innerHTML;
            }
          });
      });
    }
  }
  
  function showNotification(message) {
    // Crear notificación temporal
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      font-size: 14px;
      animation: slideIn 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  function checkAndAddTote() {
    if (isProcessing) return;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let totalWithoutTote = cart.total_price;
        const toteItem = cart.items.find(item => item.product_id === TOTE_PRODUCT_ID);
        
        if (toteItem) {
          totalWithoutTote = cart.total_price - toteItem.final_line_price;
        }
        
        const hasTote = cart.items.some(item => item.product_id === TOTE_PRODUCT_ID);
        
        console.log('Total sin TOTE:', totalWithoutTote, 'Umbral:', THRESHOLD, 'Tiene TOTE:', hasTote);
        
        if (totalWithoutTote >= THRESHOLD && !hasTote) {
          isProcessing = true;
          console.log('✓ Añadiendo TOTE al carrito...');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: TOTE_VARIANT_ID,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('✓ TOTE añadida correctamente:', data);
            isProcessing = false;
            
            // Actualizar UI sin recargar
            updateCartUI();
            
            // Mostrar notificación
            showNotification('¡TOTE añadida! Será gratis en el checkout 🎉');
          })
          .catch(error => {
            console.error('✗ Error añadiendo TOTE:', error);
            isProcessing = false;
          });
        }
      })
      .catch(error => console.error('✗ Error obteniendo carrito:', error));
  }
  
  // Ejecutar al cargar la página con delay
  function init() {
    setTimeout(checkAndAddTote, 1000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Escuchar eventos de actualización del carrito
  document.addEventListener('cart:updated', () => {
    setTimeout(checkAndAddTote, 500);
  });
  
  // Observar cambios en el carrito
  if (window.location.pathname.includes('/cart')) {
    setInterval(checkAndAddTote, 3000);
  }
})();
